<div class="flex flex-row justify-end items-center">
  <button mat-icon-button class="close-button" mat-dialog-close>
    <mat-icon class="close-icon" color="accent">close</mat-icon>
  </button>
</div>
<div class="px-[10px]" [formGroup]="form">
  <h2 *ngIf="data.isEdit === false" class="font-bold text-left text-xl" mat-dialog-title>
    {{utils.traslatei18n('Insert Data Mining Information')}}
  </h2>
  <div *ngIf="form" class="flex-col flex" formGroupName="contactReason">
    <span class="text-sm font-bold">{{utils.traslatei18n('Contact Reason')}}</span>
    <div class="flex-row gap-4 flex">
      <mat-form-field class="w-[50%]" appearance="outline">
        <mat-label>{{utils.traslatei18n('Category Level 1')}}</mat-label>
        <mat-select formControlName="categoryLevel1">
          <!-- <mat-option *ngFor="let cr of contactReasons;let i = index" [value]="cr.id"  (click)="onSelection(i,0)"> -->
          <mat-option *ngFor="let cr of contactReasons;let i = index" [value]="cr.id">
            {{cr.defaultDescription}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-[50%]" appearance="outline">
        <mat-label>{{utils.traslatei18n('Category Level 2')}}</mat-label>
        <mat-select  #contactReasonSelect formControlName="categoryLevel2">
          <mat-option  *ngFor="let cr of currentContactsChild" [value]="cr.id">
            {{cr.defaultDescription}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="flex-col flex" formGroupName="dissatisfactionReason1">
    <span class="text-sm font-bold">{{utils.traslatei18n('Dissatisfaction Reason 1')}}</span>
    <div class="flex-row gap-4 flex">
      <mat-form-field class="w-[50%]" appearance="outline">
        <mat-label>{{utils.traslatei18n('Category Level 1')}}</mat-label>
          <mat-select formControlName="categoryLevel1">
            <mat-option *ngFor="let dr of dissatisfactionReasons;let i =index" [value]="dr.id">
              {{dr.defaultDescription}}
            </mat-option>
          </mat-select>
      </mat-form-field>
      <mat-form-field class="w-[50%]" appearance="outline">
        <mat-label>{{utils.traslatei18n('Category Level 2')}}</mat-label>
        <mat-select  #dissReasonSelect formControlName="categoryLevel2">
          <mat-option *ngFor="let dr of currentDissChild" [value]="dr.id">
            {{dr.defaultDescription}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="flex-col flex" formGroupName="dissatisfactionReason2">
    <span class="text-sm font-bold">{{utils.traslatei18n('Dissatisfaction Reason 2')}}</span>
    <div class="flex-row gap-4 flex">
      <mat-form-field class="w-[50%]" appearance="outline">
        <mat-label>{{utils.traslatei18n('Category Level 1')}}</mat-label>
        <mat-select  formControlName="categoryLevel1">
          <mat-option *ngFor="let dr of dissatisfactionReasons2;let i =index" [value]="dr.id">
            {{dr.defaultDescription}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-[50%]" appearance="outline">
        <mat-label>{{utils.traslatei18n('Category Level 2')}}</mat-label>
        <mat-select  #dissReasonSelect2  formControlName="categoryLevel2">
          <mat-option *ngFor="let dr of currentDissChild2" [value]="dr.id">
            {{dr.defaultDescription}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <mat-form-field class="w-[100%]" appearance="outline">
    <mat-label>{{utils.traslatei18n('Person Entering Info')}}</mat-label>
    <input placeholder="Person entering info" formControlName="personEnteringInfo" matInput>
  </mat-form-field>
  <mat-form-field class="w-[100%]" appearance="outline">
    <mat-label>{{utils.traslatei18n('Description')}}</mat-label>
    <input placeholder="description" formControlName="description" matInput>
  </mat-form-field>

  <div class="flex-row gap-4 flex">
    <mat-form-field class="w-[50%]" appearance="outline">
      <mat-label>{{utils.traslatei18n('Survey Id')}}</mat-label>
      <input placeholder="reason" formControlName="surveyId" matInput>
    </mat-form-field>
    <mat-form-field class="w-[50%]" appearance="outline">
      <mat-label>{{utils.traslatei18n('Survey Date')}}</mat-label>
      <input placeholder="Date" [matDatepicker]="surveyPicker" formControlName="surveyDate" matInput>
      <mat-datepicker-toggle matSuffix [for]="surveyPicker"></mat-datepicker-toggle>
      <mat-datepicker #surveyPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>{{utils.traslatei18n('Outlet Id')}}</mat-label>
    <input placeholder="reason" formControlName="outletId" matInput>
  </mat-form-field>
  <mat-form-field class="w-full" appearance="outline">
    <mat-label>{{utils.traslatei18n('Date Start')}}</mat-label>
    <input placeholder="Date" [matDatepicker]="startPicker" formControlName="dateStart" matInput>
    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
    <mat-datepicker #startPicker></mat-datepicker>
  </mat-form-field>

  <div class="p-2" *ngIf="data.isEdit && data.attach">
    <div
      class="flex flex-row justify-center items-center w-full rounded-lg hover:text-white hover:bg-[#223e80]  py-2 cursor-pointer"
      matRipple (click)="downloadFile()">
      <div class="px-1">{{utils.traslatei18n('Download File')}}</div>
      <mat-icon class="px-1">file_download</mat-icon>
    </div>
  </div>

  <div class="flex w-full items-center justify-center bg-grey-lighter py-2 mb-4 group">
    <label *ngIf="!file"
      class="w-full flex flex-col items-center px-6 py-6 bg-white text-blue rounded-lg border-2 border-[#223e80] border-dashed tracking-wide uppercase   cursor-pointer hover:bg-[#223e80] hover:text-white">

      <img alt="up" src='../../../../assets/svg/up.svg' class="w-8 h-8 text-[#223e80] " />
      <span class="mt-2 text-base leading-normal ">{{utils.traslatei18n('Select a file')}}</span>
      <input type='file' (change)="incomingfile($event)" class="hidden" accept=".pdf, .doc, .xlsx, .txt" />

    </label>
    <div *ngIf="file"
      class="w-full flex flex-col items-center px-6 py-6 bg-white text-blue rounded-lg border-2 border-[#223e80] border-dashed tracking-wide uppercase   cursor-pointer  ">
      <img alt="load" src='../../../../assets/svg/load.svg' class="w-8 h-8 text-[#223e80] " />
      <button mat-button>
        <div class="flex flex-row justify-between items-center" (click)="deleteFile()">
          <div class="mt-2 text-base leading-normal ">{{file.name}}</div>
          <mat-icon class="mx-2">delete</mat-icon>
        </div>

      </button>
      <div *ngIf="sizeError" class="text-red-500">{{utils.traslatei18n('uploaded file is too large')}}</div>
    </div>
  </div>
  <mat-dialog-actions class="justify-between">
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <div class="w-full">
      <div class="flex flex-col justify-center items-center m-auto">
        <button mat-raised-button color="accent" [disabled]="!this.form.valid" [mat-dialog-close]="returnValue()"
          class="w-1/3">
          {{ this.utils.traslatei18n("Save") }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>